import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useDropdown,
  UsecitiesDropdowns,
  useStatesDropdowns,
} from "../../actions/authActions";
import Icons from "../../assets/icon";
import { useForm } from "react-hook-form";
import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import { useAuth } from "../../context/authContext";
import { useSelector } from "react-redux";
import textWeight from "../../utils/textWeight";
export default () => {
  const navigate = useNavigate();
  const { TextWeight } = textWeight();
  const [filterPopup, setFilterPopup] = useState(false);
  const { isLoggedIn } = useAuth();
  const userData = useSelector((state) => state.app.userData.userData);
  const [filters, setFilters] = useState({});
  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      jobtitle: "",
      expirydate: "",
      postCode: "",
      salaryFrom: "",
      salaryTo: "",
      positions: "",
      description: "",
      job_shift: "",
      bodyTattoos: "",
      bodyPiercings: "",
    },
  });
  const [select, setSelect] = useState({
    countries: "",
    states: "",
    city: "",
    gender: "",
    ethinicity: "",
    hairTypes: "",
    eyeColors: "",
    experienceLevel: "",
  });
  const baseURL = process.env.REACT_APP_BASE_URL;

  const {
    data: talentData,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
    error,
  } = useInfiniteQuery({
    queryKey: ["talents", filters],
    queryFn: ({ pageParam = 1 }) =>
      axios
        .get(`${baseURL}/api/v2/talent`, {
          params: {
            page: pageParam,
            ...filters,
          },
        })
        .then((res) => res.data.data),
    getNextPageParam: (lastPage) => {
      return lastPage.has_more_pages ? lastPage.current_page + 1 : undefined;
    },
  });
  useEffect(() => {
    if (!isLoading) {
      setFilterPopup(false);
    }
  }, [isLoading]);

  const handleDropdwonSelect = (name, value) => {
    setSelect((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const { data: dropdowns, isLoading: dropdownLoading } = useDropdown();
  const { data: states, isLoading: isLoadingStates } = useStatesDropdowns(
    select.country
  );
  const { data: cities, isLoading: citiesisLoading } = UsecitiesDropdowns(
    select?.states
  );

  const [rangeHeight, setRangeHeight] = useState([null, null]);
  const [tooltipPosHeight, setTooltipPosHeight] = useState([0, 0]);
  const sliderRefHeight = useRef(null);

  const updateTooltipPosHeight = (value) => {
    const [minVal, maxVal] = value;
    const percentStart = ((minVal - 120) / (220 - 120)) * 100;
    const percentEnd = ((maxVal - 120) / (220 - 120)) * 100;
    setTooltipPosHeight([percentStart, percentEnd]);
  };

  const handleInputHeight = (value, userInteraction) => {
    setRangeHeight(value);
    if (userInteraction) updateTooltipPosHeight(value);
  };

  useEffect(() => {
    updateTooltipPosHeight(rangeHeight);
  }, [rangeHeight]);

  const [rangeWeight, setRangeWeight] = useState([null, null]);
  const sliderRefWeight = useRef(null);
  const [tooltipPosWeight, setTooltipPos] = useState([0, 0]);
  const updateTooltipPos = (value) => {
    const [minVal, maxVal] = value;
    const percentStart = ((minVal - 25) / (200 - 25)) * 100;
    const percentEnd = ((maxVal - 25) / (200 - 25)) * 100;
    setTooltipPos([percentStart, percentEnd]);
  };

  const handleInputWeight = (value, userInteraction) => {
    setRangeWeight(value);
    if (userInteraction) updateTooltipPos(value);
  };

  useEffect(() => {
    updateTooltipPos(rangeWeight); // Initial set
  }, [rangeWeight]);

  const [rangeAge, setRangeAge] = useState([null, null]);
  const [tooltipPosAge, setTooltipPosAge] = useState([0, 0]);
  const sliderRefAge = useRef(null);
  const updateTooltipPosAge = (value) => {
    const [minVal, maxVal] = value;
    const percentStart = ((minVal - 6) / (90 - 6)) * 100;
    const percentEnd = ((maxVal - 6) / (90 - 6)) * 100;
    setTooltipPosAge([percentStart, percentEnd]);
  };

  const handleInputAge = (value, userInteraction) => {
    setRangeAge(value);
    if (userInteraction) updateTooltipPosAge(value);
  };

  useEffect(() => {
    updateTooltipPosAge(rangeAge);
  }, [rangeAge]);
  const handleTalent = (id) => {
    if (!isLoggedIn) {
      navigate("/login");
    } else {
      navigate(`/talent/${id}`);
    }
  };
  const onSubmit = (data, e) => {
    e.preventDefault();
    const newFilters = {};
    if (select.country) newFilters["country_id[]"] = select.country;
    if (select?.states) newFilters["state_id[]"] = select?.states;
    if (select.city) newFilters["city_id[]"] = select.city;
    if (select.gender) newFilters["gender[]"] = select.gender;
    if (select.ethinicity) newFilters["ethinicity_id[]"] = select.ethinicity;
    if (select.hairTypes) newFilters["hair_type[]"] = select.hairTypes;
    if (select.eyeColors) newFilters["eye_colors[]"] = select.eyeColors;
    if (rangeAge[0] != null && rangeAge[1] != null) {
      newFilters["age[]"] = rangeAge;
    }
    if (rangeHeight[0] != null && rangeHeight[1] != null) {
      newFilters["height[]"] = rangeHeight;
    }
    if (rangeWeight[0] != null && rangeWeight[1] != null) {
      newFilters["weight[]"] = rangeWeight;
    }
    if (data.bodyTattoos !== undefined && data.bodyTattoos !== "") {
      newFilters["tattoos[]"] = data.bodyTattoos;
    }

    if (data.bodyPiercings !== undefined && data.bodyPiercings !== "") {
      newFilters["piercings[]"] = data.bodyPiercings;
    }

    if (select.experienceLevel)
      newFilters["experience_level[]"] = select.experienceLevel;
    setFilters(newFilters); // This triggers the useQuery refetch
  };
  const resetFilters = () => {
    setFilters({});
    setSelect("");
    reset();
    setRangeWeight([null, null]);
    setRangeHeight([null, null]);
    setRangeAge([null, null]);
  };
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">Error loading Talent: {error.message}</p>
      </div>
    );
  }
  const RadioValueandLable = [
    { id: 1, title: "Yes" },
    { id: 0, title: "No" },
  ];
  return {
    // states
    filterPopup,
    setFilterPopup,
    rangeAge,
    setRangeAge,
    rangeHeight,
    setRangeHeight,
    rangeWeight,
    setRangeWeight,

    // refs
    sliderRefAge,
    sliderRefHeight,
    sliderRefWeight,

    // tooltips
    tooltipPosAge,
    tooltipPosHeight,
    tooltipPosWeight,

    // handlers
    handleTalent,
    handleDropdwonSelect,
    handleInputAge,
    handleInputHeight,
    handleInputWeight,
    resetFilters,
    onSubmit,

    // data
    talentData,
    dropdowns,
    states,
    cities,
    dropdownLoading,
    isLoading,
    isLoadingStates,
    citiesisLoading,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,

    // forms
    errors,
    register,
    control,
    handleSubmit,
    RadioValueandLable,

    // UI
    Icons,
    select,
    TextWeight,
  };
};
